module.exports = {
  common: {
    ok: 'OK',
    cancel: 'CANCEL'
  },
  language: {
    name: 'English'
  },
  header: {
    lang: '中文版',
    home: 'HOME',
    allproduct: 'Product Category',
    product: 'PRODUCT',
    productccc: '3C PRODUCT',
    video: 'VIDEO',
    star: 'SEASUNSTAR',
    news: 'NEWS',
    plan: 'Exhibition Plan',
    about: 'ABOUT',
    contact: 'CONTACT',
    Exchange: 'Exchange Rates',
    search: 'search',
    langageimg: 'cn.png',
    computry: 'SEA & SUN TOYS TRADE CO.,LTD',
    welcome: 'welcome!',
    login: 'login',
    register: 'register',
    registernew: 'register as new user',
    notuser: 'no account',
    highsearch: 'Advanced search',
    buyshop: 'My Cart',
    account: 'ACCOUNT',
    password: 'PASSWORD',
    name: 'NAME',
    phone: 'PHONE',
    keyword: 'Please Inter Keyword'
  },
  home: {
    hot: 'Sales Ranking',
    halfmonth: 'half a month',
    onemonth: 'one month',
    threemonths: 'three months',
    halfyear: 'half a year',
    newproduct: 'EVERYDAY NEW PRODUCTS',
    videoproduct: 'PRODUCT VIDEO',
    productSearch: 'PRODUCT SEARCH',
    productName: 'NAME：',
    productItem: 'NO：',
    productPackage: 'PACKAGE：',
    productP: 'ITEMNO：',
    productbc: 'KIND：',
    productsc: 'CLASS：',
    productnum: 'BOX NUM：',
    productpb: 'PRICE：',
    productpe: '~　　',
    search: 'SEARCH',
    PIK: 'Please inter content',
    PS: 'Please Select'
  },
  contact: {
    name: 'NAME',
    phone: 'PHONE',
    email: 'E-MAIL',
  },
  footer: {
    lang: '中文版',
    home: '　　HOME　　',
    product: 'PRODUCT',
    video: 'VIDEO',
    news: 'NEWS',
    about: 'ABOUT',
    concact: 'Address：RM B, 7/F GOOD LUCK IND BLDG, 105 HOW HING ST KWUN TONG KLN, HONGKONG|　Email:seasunhk@163.com',
    power: 'Copyright SEA&SUN TOYS TRADING COMPANY LIMITED 2022-2030 All Right Reserved ',
    address: ''
  },
  productdetails: {
    gologin: 'Please Login',
    cpzl: 'Product Category：',
    jrgwc: 'Add Cart',
    cpbz: 'Pkg：',
    wxsl: 'Outer Packing：',
    lwh: 'LWH：',
    outlwh: 'Carton Size：',
    cprq: 'Date：',
    nhgs: 'Inner Box：',
    tj: 'CBM(m3)：',
    mj: 'GW/NW：',
    spms: 'Product Description：',
    jcxj: 'Basic Information：',
    cphh: 'ItemNo：',
    cjbh: 'FactoryNo：',
    cpmc: 'Name：',
    ccbz: 'Size & Package：',
    ccclfs: 'Measurement Method：',
    tccp: 'Same Factory：'
  },
  product: {
    new: 'new',
    hot: 'hot',
    price: 'price',
    video: 'video',
    total: 'total',
    productcount: 'products'
  },
  cart: {
    exporte: 'exporte',
    mutidelete: 'mutidelete',
    image: 'image',
    info: 'info',
    number: 'number:',
    name: 'name:',
    delete: 'delete',
    count: 'count',
    price: 'price',
    subtotal: 'subtotal',
    operation: 'operation'
  },
  about: {
    companyintroduction: 'company introduction',
    enterprisehonor: 'contact us',
    sampleexhibits: 'sample exhibits',
    newstendency: 'news tendency'
  }
}


// WEBPACK FOOTER //
// ./src/components/language/en.js